import React, { useState } from 'react';
import apis from '../../utils/apis';
import httpAction from '../../utils/httpAction';
import { clearAuth } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';

const inputStyle = { width:'100%', padding:12, border:'1px solid #d0d5dd', borderRadius:12 };

export default function ChangePassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ currentPassword:'', newPassword:'' });
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await httpAction({ url: apis().changePassword, method:'POST', body: form });
    setLoading(false);
    if (result?.status) {
      clearAuth();
      navigate('/admin/login');
    }
  };

  return (
    <div style={{ maxWidth:560, background:'#fff', padding:24, borderRadius:20, boxShadow:'0 12px 30px rgba(15,23,42,.06)' }}>
      <h2>Change Password</h2>
      <p style={{ color:'#667085' }}>Use a strong password with at least 8 characters.</p>
      <form onSubmit={submitHandler} style={{ display:'grid', gap:14 }}>
        <input style={inputStyle} type='password' placeholder='Current password' value={form.currentPassword} onChange={(e)=>setForm({...form, currentPassword:e.target.value})} required />
        <input style={inputStyle} type='password' placeholder='New password' value={form.newPassword} onChange={(e)=>setForm({...form, newPassword:e.target.value})} required />
        <button disabled={loading} type='submit' style={{ padding:14, border:'none', borderRadius:12, background:'#0f5ef7', color:'#fff', fontWeight:700 }}>{loading ? 'Updating...' : 'Update Password'}</button>
      </form>
    </div>
  );
}
